import React, { useContext, useEffect, useState, useCallback } from "react";
import Sidebar from "../components/Sidebar";
import { Navigate, useLocation } from "react-router-dom";
import AiVisibilitySidebar from "../components/AiVisibility/AiVisibilitySidebar";
import Content from "../components/Content";
import Notification from "../components/Notification";
import { ProductContext } from "../store";
import Cookies from "js-cookie";
import { PostData } from "../services/FetchData";
import { getMonitoringProject } from "../services/monitoringApi";

const FULL_BLEED_PATHS = [
	// "/aivisibility/report",
	// "/aivisibility/recommendations/view",
	"/aivisibility/writing-assistance/view",
	"/aivisibility/dual-lens/view",
	"/aivisibility/writing-recommendations",
	// "/aivisibility/monitoring",
];

const AiVisibility = () => {
	const [isLogged, setIsLogged] = useState(true);
	const mainContent = React.useRef(null);
	const location = useLocation();
	const {
		setUserData,
		setUserLoader,
		setWebsiteLoader,
		setWebsiteData,
		setCurrentWebsiteId,
		setUserWebsitePlan,
		setProductTypes,
		loadVisualEditor,
		setLoadVisualEditor,
		productTypes,
		userLoader,
		websiteLoader,
		currentWebsiteId,
		setMonitoringEnabled,
	} = useContext(ProductContext);

	const hideInnerSidebar = FULL_BLEED_PATHS.some(
		(path) =>
			location.pathname === path || location.pathname.startsWith(`${path}/`)
	);

	useEffect(() => {
		setLoadVisualEditor(hideInnerSidebar);
		return () => setLoadVisualEditor(false);
	}, [hideInnerSidebar, setLoadVisualEditor]);

	useEffect(() => {
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
		if (mainContent.current) {
			mainContent.current.scrollTop = 0;
		}
	}, [location]);

	const getUserDetail = useCallback(() => {
		setUserLoader(true);
		setWebsiteLoader(true);
		PostData("ms1", "api/v1/user/getUserDetail").then((result) => {
			if (result !== "Invalid" && result !== undefined && result.status === "success") {
				setUserData(result.data.user);
				let websiteId = Cookies.get("_website_id");
				if (result.data.websites && Array.isArray(result.data.websites) && result.data.websites.length > 0) {
					if (!Cookies.get("_website_id")) {
						Cookies.set("_website_id", result.data.websites[0].websiteId);
						websiteId = result.data.websites[0].websiteId;
						setCurrentWebsiteId(result.data.websites[0].websiteId);
					} else {
						setCurrentWebsiteId(Cookies.get("_website_id"));
					}
					const websitesLocal = result.data.websites;
					const websiteDataLocal = {};
					for (let i = 0; i < websitesLocal.length; i++) {
						const currentWebsite = websitesLocal[i];
						websiteDataLocal[currentWebsite.websiteId] = currentWebsite;
					}
					setUserWebsitePlan(websiteDataLocal[websiteId].websiteUserPlan);
					const productsMapping = websiteDataLocal[websiteId].productsMapping || [];
					setProductTypes(productsMapping);
					setWebsiteData(websiteDataLocal);
				}
			}
			setWebsiteLoader(false);
			setUserLoader(false);
		});
	}, [
		setUserData,
		setUserLoader,
		setWebsiteLoader,
		setWebsiteData,
		setCurrentWebsiteId,
		setUserWebsitePlan,
		setProductTypes,
	]);

	useEffect(() => {
		const token = Cookies.get("_cb_search_token");
		if (!token) {
			setIsLogged(false);
		} else {
			getUserDetail();
		}
	}, [getUserDetail]);

	// Sidebar Monitoring tabs: enable state from API for current Store.
	// Do not flip to false before the request resolves — that collapses the
	// submenu and causes a visible flicker on every navigation/refetch.
	useEffect(() => {
		if (!currentWebsiteId) {
			setMonitoringEnabled(false);
			return;
		}
		if (userLoader || websiteLoader) return;

		let cancelled = false;
		getMonitoringProject(currentWebsiteId).then((res) => {
			if (!cancelled) {
				setMonitoringEnabled(Boolean(res.ok && res.project));
			}
		});
		return () => {
			cancelled = true;
		};
	}, [
		currentWebsiteId,
		userLoader,
		websiteLoader,
		setMonitoringEnabled,
	]);

	if (!isLogged) {
		return <Navigate to="/auth/login" replace />;
	}

	if (!userLoader && productTypes != null && !productTypes.includes("aivisibility")) {
		return <Navigate to="/user/dashboard" replace />;
	}

	return (
		<section className="applicationWrapper" ref={mainContent}>
			<div className="applicationContentWrap">
				<Sidebar />
				{!loadVisualEditor && <AiVisibilitySidebar />}
				<Content type="aivisibility" />
			</div>
			<Notification />
		</section>
	);
};

export default AiVisibility;
